import { Injectable } from '@angular/core'
import { RequestService } from '../request/request.service'
import { environment } from '../../../environments/environment'
import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http'
import { BehaviorSubject, Observable, tap } from 'rxjs'
import { QueryGet } from '../../shared/query-types'
import { Pagination } from '../../models/pagination.interface'
import { Profession, ProfessionDTO } from '../../models/profession.interface'
import { AsyncFormValidation } from '../../interceptors/error.interceptor'

@Injectable({
    providedIn: 'root',
})
export class ProfessionService {
    httpOptions = {
        headers: new HttpHeaders({}),
    }
    private apiUrl = environment.service_1 + 'professions/'
    private profesions = new BehaviorSubject<Profession[]>([])
    profesions$ = this.profesions.asObservable()

    private asyncErrorValidation =
        new BehaviorSubject<AsyncFormValidation | null>(null)
    asyncErrorValidation$ = this.asyncErrorValidation.asObservable()

    private professionsSelected = new BehaviorSubject<Profession | null>(null)
    $professionsSelected = this.professionsSelected.asObservable()

    constructor(
        private requestService: RequestService,
        private http: HttpClient
    ) {}

    setProfesions(profesions: Profession[]) {
        this.profesions.next(profesions)
    }

    setprofession(profession: Profession) {
        this.professionsSelected.next(profession)
    }

    allProfesion(): Observable<Profession[]> {
        return this.http.get<Profession[]>(this.apiUrl, {
            headers: this.httpOptions.headers,
        })
    }

    allProfesions(queryParams: QueryGet): Observable<Pagination<Profession[]>> {
        return this.requestService.get<Profession[]>(this.apiUrl, queryParams)
    }

    deleteProfesion(id: number): Observable<void> {
        return this.http.delete<void>(this.apiUrl + id + '/')
    }

    updateProfession(id: number, profession: ProfessionDTO & { id: number }) {
        return this.http.put<Profession>(this.apiUrl + id + '/', profession).pipe(
            tap({
                error: (err: HttpErrorResponse) => {
                    this.asyncErrorValidation.next(err.error)
                },
            })
        )
    }
}
